/**
 * Following a signed download link.
 *
 * A one-line wrapper around `location.assign`, and it exists for a reason
 * worth stating: jsdom defines `location` and its methods as
 * non-configurable, so a component calling `window.location.assign` directly
 * cannot be tested at all — the property can be neither spied nor redefined.
 * Routing it through a module boundary means a test can stub this function
 * instead, and the component's behaviour becomes observable.
 *
 * A real navigation rather than a synthetic `<a download>` click: the response
 * carries `Content-Disposition: attachment`, so the browser saves the file and
 * stays on the page — and this works for an S3 URL on another origin, which a
 * `download` attribute would silently ignore.
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 7.8, PRD §5.10
 */
export function followDownloadLink(url: string): void {
  window.location.assign(url);
}
